import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import LockOutlined from '@ant-design/icons/LockOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';

import { ACCOUNT_SETTINGS_TAB_KEY } from 'utils/accountSettings';

// ==============================|| HEADER PROFILE - SETTING TAB ||============================== //

export default function SettingTab({ onNavigate }) {
  const navigate = useNavigate();

  const closeAndGo = (path) => {
    onNavigate?.();
    navigate(path);
  };

  const openAccountSettings = () => {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(ACCOUNT_SETTINGS_TAB_KEY, 'my-account');
    }
    closeAndGo('/settings?tab=my-account');
  };

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton onClick={openAccountSettings}>
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText primary="Account settings" secondary="Subscription and account" />
      </ListItemButton>
      <ListItemButton onClick={() => closeAndGo('/privacy-policy')}>
        <ListItemIcon>
          <LockOutlined />
        </ListItemIcon>
        <ListItemText primary="Privacy" secondary="Privacy policy" />
      </ListItemButton>
    </List>
  );
}

SettingTab.propTypes = {
  onNavigate: PropTypes.func
};
